







































import Vue from "vue";
import Component from "vue-class-component";
import Chart from "@/components/Chart.vue"
import Task from "@/lib/Task";
import TargetTask from "@/lib/TargetTask";
import dayjs from "dayjs";
import Project from "@/lib/Project";

    type Series = {
        value: number,
        name: string,
        itemStyle: {color: string}
    }
    @Component(
        {components: {Chart}
    })
    export default class Stats extends Vue{
        
        beforeCreate():void {
            this.$store.commit("fetchTaskList");
            this.$store.commit("fetchProjectList")
        }

        get hasData():boolean {
            const task_target_list =  this.$store.state.targetTaskList as TargetTask[];
            if(task_target_list === undefined || task_target_list.length === 0) return false;
            return task_target_list.filter(i => i.status === 2).length > 0;

            // const task_list = this.$store.state.taskList as Task[];
            // if(task_list === undefined || task_list.length === 0) return false;
            // return task_list.filter(i => i.status === 2).length > 0;
        }

        // 今年完成待办
        get taskNumYesterday():number {
            const task_target_list = this.$store.state.targetTaskList as TargetTask[];            
            if(task_target_list && task_target_list.length > 0) {
                return task_target_list.filter((i)=>{        
                    return i.finishTime && dayjs(i.finishTime).isSame(dayjs(new Date()), 'year') && i.status !== 0;
                }).length;
            } else {
                return 0;
            }

            // const task_list = this.$store.state.taskList as Task[];            
            // if(task_list && task_list.length > 0) {
            //     return task_list.filter((i)=>{                    
            //         return i.finishTime && dayjs(i.finishTime).isSame(dayjs(new Date()).add(-1, 'day'), 'day') && i.status !== 0;
            //     }).length;
            // } else {
            //     return 0;
            // }
        }

        // 今年完成率
        get taskRateYesterday():string {
            const task_target_list = this.$store.state.targetTaskList as TargetTask[];
            let taskNum = task_target_list.filter((i)=>{
                    if(i.dueDate === null) return false;
                    return dayjs(new Date(i.dueDate)).isSame(dayjs(new Date()), 'year') && i.status !== 0;
                }).length;
            let finishNum = task_target_list.filter((i)=>{
                    if(i.dueDate === null) return false;
                    return i.finishTime 
                            && dayjs(i.finishTime).isSame(dayjs(new Date()), 'year') 
                            && dayjs(new Date(i.dueDate)).isSame(dayjs(new Date()), 'year')
                            && i.status === 2;
            }).length;
            if (taskNum === 0) return '0';
            return ((finishNum / taskNum) * 100).toFixed(0);

            // const task_list = this.$store.state.taskList as Task[];
            // let taskNum = task_list.filter((i)=>{
            //         if(i.due_date === null) return false;
            //         return dayjs(new Date(i.due_date)).isSame(dayjs(new Date()).add(-1,'day'), 'day') && i.status !== 0;
            //     }).length;
            // let finishNum = task_list.filter((i)=>{
            //         if(i.due_date === null) return false;
            //         return i.finishTime 
            //                 && dayjs(i.finishTime).isSame(dayjs(new Date()).add(-1, 'day'), 'day') 
            //                 && dayjs(new Date(i.due_date)).isSame(dayjs(new Date()).add(-1, 'day'), 'day')
            //                 && i.status === 2;
            // }).length;
            // if (taskNum === 0) return '0';
            // return ((finishNum / taskNum) * 100).toFixed(0);
        }

        get taskThisWeek():TargetTask[] {
            const task_target_list = this.$store.state.targetTaskList as TargetTask[];
            const currentDay = new Date();
            
            if(task_target_list && task_target_list.length > 0) {                
                 return task_target_list.filter((i)=>{
                    if (i.status === 0) return false;
                    if (i.dueDate === null) return false;
                    return true;
                });
            } else {
                return [];
            }
            
            // const task_list = this.$store.state.taskList as Task[];
            // const currentDay = new Date();
            // const thisWeekStart = dayjs(currentDay).add(-(currentDay.getDay() - 1), 'day');
            // const thisWeekEnd = thisWeekStart.add(7, 'day');
            
            // if(task_list && task_list.length > 0) {                
            //      return task_list.filter((i)=>{
            //         if (i.status === 0) return false;
            //         if (i.due_date === null) return false;
            //         if (dayjs(new Date(i.due_date)).isAfter(thisWeekStart.add(-1, 'day'), 'day') && dayjs(i.due_date).isBefore(thisWeekEnd))
            //             return true;
            //     });
            // } else {
            //     return [];
            // }
            
        }

        get finishedTaskNumThisWeek():number {
            
            return this.taskThisWeek.filter((i)=>{
                return i.status === 2;
            }).length;
        }

        get taskRateThisWeek():number {
            if (this.taskThisWeek.length === 0) {
                return 0;
            } else {
                return Number((this.finishedTaskNumThisWeek / this.taskThisWeek.length * 100).toFixed(0));
            }
        }

        get allFinishedTask():Task[] {
            const task_list = this.$store.state.taskList as Task[];
            return task_list.filter(i => i.status === 2);
        }

        get projectNameList():string[] {
            const projectList = this.$store.state.projectList as Project[];
            const task_target_list = this.$store.state.targetTaskList as TargetTask[];
            let result = [];
            for(let p of projectList) {
                let num = task_target_list.filter(item => item.targetId === p.id && item.status === 2).length;
                if(num !== 0) {
                    result.push(p.name);
                } 
            }


            // const projectList = this.$store.state.projectList as Project[];
            // const taskList = this.$store.state.taskList as Task[];
            // const taskNum = taskList.filter(i => i.status === 2 && i.project_id === '-1').length;            
            // let result = [];
            // if(taskNum > 0) {
            //     result.push('收集箱');
            // }
            // for(let p of projectList) {
            //     let num = taskList.filter(item => item.project_id === p.id && item.status === 2).length;
            //     if(num !== 0) {
            //         result.push(p.name);
            //     } 
            // }   
            
            return result;
        }

        

        get projectDataList():Series[] {

            const projectList = this.$store.state.projectList as Project[];
            const task_target_list = this.$store.state.targetTaskList as TargetTask[];

            const taskNum = task_target_list.filter(i => i.status === 2 && i.targetId === '-1').length;
            let result = [];
            if(taskNum > 0) {
                result.push({value: taskNum, name: '收集箱', itemStyle: {color: '#808CCF'}});
            }

            for(let p of projectList) {
                let num = task_target_list.filter(item => item.targetId === p.id && item.status === 2).length;
                if(num !== 0) {
                    result.push({ value: num, name: p.name, itemStyle: {color: p.color}});
                } 
            }


            // const projectList = this.$store.state.projectList as Project[];
            // const taskList = this.$store.state.taskList as Task[];

            // const taskNum = taskList.filter(i => i.status === 2 && i.project_id === '-1').length;
            // let result = [];
            // if(taskNum > 0) {
            //     result.push({value: taskNum, name: '收集箱', itemStyle: {color: '#808CCF'}});
            // }

            // for(let p of projectList) {
            //     let num = taskList.filter(item => item.project_id === p.id && item.status === 2).length;
            //     if(num !== 0) {
            //         result.push({ value: num, name: p.name, itemStyle: {color: p.color}});
            //     } 
            // }

            return result;
        }

        option = {
            baseOption: {
                title : {
                text: '目标情况概览',
                subtext: '各目标已完成任务占总完成任务比',
                x:'center'
            },
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c}<br/>完成率：{d}%"
            },
            legend: {
                data: this.projectNameList
            },
            toolbox: {
                show : true,
                feature : {

                    magicType : {
                        show: true,
                        type: ['pie', 'funnel']
                    },
                }
            },
            calculable : true,
            series : [
                {
                    name:'完成任务占比',
                    type:'pie',
                    roseType : 'area',
                    data: this.projectDataList,
                }
            ],
            },
            media: [
                {
                    option: {
                        legend: {
                            right: 'center',
                            bottom: 0,
                            orient: 'horizontal'
                        },
                        series: [
                            {
                                radius: [30, '50%'],
                                center: ['50%', '50%']
                            }
                        ]
                    },   
                },
                {
                    query: {
                        minAspectRatio: 1
                    },
                    option: {
                        legend: {
                            right: 'center',
                            bottom: 0,
                            orient: 'horizontal'
                        },
                        series: [
                            {
                                radius: [30, '50%'],
                                center: ['50%', '50%']
                            }
                        ]
                    }
                },
                {
                    query: {
                        maxAspectRatio: 1
                    },
                    option: {
                        legend: {
                            right: 'center',
                            bottom: 0,
                            orient: 'horizontal'
                        },
                        series: [
                            {
                                radius: [30, '50%'],
                                center: ['50%', '50%']
                            }
                        ]
                    }
                },
                {
                    query: {
                        maxWidth: 500
                    },
                    option: {
                        legend: {
                            right: 10,
                            top: '15%',
                            orient: 'vertical'
                        },
                        series: [
                            {
                                radius: [30, '50%'],
                                center: ['50%', '50%']
                            }
                        ]
                    }
                }
            ]
        }

    }
